import Button from "../../components/Button";
import Member from "../../models/Member";
import { formatDate, getFirstDayOfMonth } from "../../utils";

interface BillingDateModalProps {
  dismissInvalidBillingDate: () => void;
  memberInstance: Member;
}

// this duplicates some logic within handleInccorectBillingDate, so that the display of date values to the user matches what we will set on member
// we could 
const BillingDateModal: React.FC<BillingDateModalProps> = ({ dismissInvalidBillingDate, memberInstance }) => {

  return (
    <div className="absolute top-0 left-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
      <div className="rounded-lg bg-white p-4">
        <h2 className="text-lg font-semibold">Invalid Billing Date</h2>
        <p>The date you entered was invalid, so we've updated your billing date to {memberInstance.billingDate}. Your effective date is {memberInstance.effectiveDate}. Go Back to the Overview step if you would like to adjust these values.</p>
        <div className="mt-4 flex justify-end gap-2">
          <Button
            className="bg-blue-500 hover:bg-blue-600 rounded px-4 py-2 text-white"
            action={dismissInvalidBillingDate}
            text="Confirm"
          />
        </div>
      </div>
    </div>
  );
};

export default BillingDateModal;
